import { render, staticRenderFns } from "./infoBox.pug?vue&type=template&id=865b6ac0&lang=pug&external"
import script from "./infoBox.js?vue&type=script&lang=js&external"
export * from "./infoBox.js?vue&type=script&lang=js&external"
import style0 from "./infoBox.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('865b6ac0')) {
      api.createRecord('865b6ac0', component.options)
    } else {
      api.reload('865b6ac0', component.options)
    }
    module.hot.accept("./infoBox.pug?vue&type=template&id=865b6ac0&lang=pug&external", function () {
      api.rerender('865b6ac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/infoBox/index.vue"
export default component.exports